/*
  Swiper init for the OraLux announcement bar.

  Notes that cost time elsewhere and are handled here on purpose:

  - Swiper is loaded with `defer`, so it may or may not have parsed by the time this file
    runs. Rather than assume an order, this waits for the global to appear and gives up
    after a bounded number of tries instead of polling forever.

  - The theme editor replaces a section's markup wholesale on every settings change, which
    leaves the old Swiper instance bound to a node that is no longer in the document. Each
    init destroys the instance already attached to that element first, and the section is
    re-initialised on shopify:section:load.

  - Autoplay is decided at init from the live media query, not from a value captured once,
    and is simply not created under reduced motion - there is nothing to pause later.
*/
(function () {
  'use strict';

  var SELECTOR = '[data-oralux-announcement]';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initOne(root) {
    var el = root.querySelector('.oralux-ab__slider');
    if (!el) return;

    /* A stale instance from a previous render would keep listening on a detached node. */
    if (el.swiper) el.swiper.destroy(true, true);

    var slides = el.querySelectorAll('.swiper-slide').length;
    if (slides === 0) return;

    var declared = parseInt(root.getAttribute('data-autoplay'), 10);
    var wantsAutoplay = declared > 0 && slides > 1 && !prefersReducedMotion();

    var options = {
      slidesPerView: 1,
      loop: slides > 1,
      speed: 400,
      allowTouchMove: slides > 1,
      a11y: { enabled: true },
      navigation: {
        prevEl: root.querySelector('.oralux-ab__arrow--prev'),
        nextEl: root.querySelector('.oralux-ab__arrow--next'),
      },
    };

    if (wantsAutoplay) {
      options.autoplay = { delay: declared, disableOnInteraction: false, pauseOnMouseEnter: true };
    }

    new window.Swiper(el, options);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(initOne);
  }

  function whenSwiperReady(run) {
    if (window.Swiper) {
      run();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      if (window.Swiper) {
        clearInterval(timer);
        run();
      } else if (++tries >= 60) {
        /* Bounded on purpose: without Swiper the bar still shows its first announcement,
           and polling forever on every page view would be wasted work for every visitor. */
        clearInterval(timer);
      }
    }, 50);
  }

  whenSwiperReady(function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    whenSwiperReady(function () {
      initAll(event.target);
    });
  });
})();
